import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => {
  const { green } = theme.palette.common;

  return {
    switchBase: {
      '&$checked + $track': {
        backgroundColor: green,
        opacity: 1,
      },
    },
    root: {
      'height': '20px',
      'width': '40px',
      'borderRadius': '14px',
      'padding': '0',
      'marginLeft': '10px',
      'marginRight': '10px',
      'justifyContent': 'flex-start',
      'alignItems': 'center',
      'display': 'flex',
      'backgroundColor': '#b4b4b4b4',
      '& $disabled + $track': {
        backgroundColor: '#e4e4e4',
      },
    },
    checked: {},
    track: {
      backgroundColor: '#b4b4b4b4',
    },
    thumb: {
      position: 'absolute',
      left: '2px',
      top: '2px',
      width: '16px',
      height: '16px',
      backgroundColor: '#ffffff',
      boxShadow: 'none',
    },
    disabled: {
      '& $root': {
        backgroundColor: '#333333',
      },
      'backgroundColor': 'gray',
    },
    label: {
      fontFamily: 'Quicksand',
      color: '#292929',
      fontSize: '14px',
      marginRight: '12px',
    },
  };
});
